import { useMemo, useState } from 'react';
import Label from '../../../../ui/label';
import ButtonDropdownOption from '../../../../ui/button-dropdown-option';
import { useDispatch } from 'react-redux';
import { setProposalType, setSECNameRenew, setSelectedProposalToRenew } from '../../../../../features/gms-proposal-forms/steps-channel-proposal_as/steps-channel-proposal_as.slice';
import { PROPOSAL_AS_IDS } from '../../../../../constant/gms-constant';
import Input from '../../../../ui/input';
import { customStyle, defaultStyle } from '../../../../../constant/custom-style';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { useDynamicQuires } from '../../../../../hooks/services/dynamic-queries/use-dynamic-quires';
import { useCreateProposalForm } from '../../../../../hooks/actions/use-create-proposal-form';
import { useProposalTypeDataUseMemo } from '../../../../../hooks/memo/use-proposal-type.usememo';
import { useToastify } from '../../../../../library/toastify/toast-provider';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';
import { useModalAccess } from '../../../../global/modal/use-modal-access';

export default function ClientInputProposalType() {

    const dispatch = useDispatch();
    const { showToastNotify } = useToastify();
    const {
        proposalAs,
        isForRenew,
        registeredNameForRenew: sECRegisteredNameRenew,
    } = useProposalTypeData()
    const { isUpdateProposal } = useModalAccess()
    const selectedProposalTypeId = proposalAs?.id

    const [openDropdown, setOpenDropdown] = useState<string | null>(null);
    const [showSuggestion, setShowSuggestion] = useState<boolean>(false);

    const { 
        statusProposalType, 
        isLoadingStatusProposalType, 
        isFetchingStatusProposalType 
    } = useQueries();

    const { 
        proposalForRenew, 
        isLoadingProposalForRenew, 
        isFetchingProposalForRenew 
    } = useDynamicQuires({ sECRegisteredNameRenew });
    const { handlePopulateRenewProposal } = useCreateProposalForm();
    
    const defaultProposalAs = useMemo(() => ({ id: 0, name: 'Select' }), []);
    const { proposalTypeOptions, proposalTypeValue } = useProposalTypeDataUseMemo({ defaultProposalAs, statusProposalType, selectedProposalTypeId });
    
    return (
        <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
            <div className="md:col-span-2">
                <Label 
                    label="Proposal as" 
                    requiredText=" *" 
                    isRequired={true} 
                    fontSize="text-xs mb-1.5" 
                />

                <div className={`relative ${isUpdateProposal ? 'cursor-not-allowed opacity-60' : ''}`}>
                    {isUpdateProposal && <div className="absolute inset-0 z-10 rounded-md" />}
                    <ButtonDropdownOption 
                        width="w-full" 
                        padding="px-3 py-2" 
                        options={proposalTypeOptions} 
                        isLoading={isLoadingStatusProposalType || isFetchingStatusProposalType} 
                        value={proposalTypeValue} 
                        onChange={(option) => { 
                            if (option.id === PROPOSAL_AS_IDS.renew) {
                                return showToastNotify('Renew proposal is not available.', 'warning'); 
                            }
                            dispatch(setProposalType(option)); 
                        }} 
                        open={openDropdown === 'proposalTypeAs'} 
                        setOpen={() => setOpenDropdown(openDropdown === 'proposalTypeAs' ? null : 'proposalTypeAs')} 
                    />
                </div>
            </div>

            {isForRenew && (
                <div className="md:col-span-3">
                    <Label 
                        label={`${proposalTypeValue?.name} Name`} 
                        fontSize="text-xs mb-1.5" 
                        requiredText=" *" 
                        isRequired={true} 
                    />

                    <div className="relative">
                        <div className="relative flex gap-2">
                            <div className="relative flex-1">
                                <Input 
                                    type="text" 
                                    name="groupName" 
                                    value={sECRegisteredNameRenew || ''} 
                                    isCustomStyle={true} 
                                    customCss={`${defaultStyle} 
                                    ${sECRegisteredNameRenew ? customStyle : ''}`} 
                                    onChange={(e) => { 
                                        const value = e.target.value; 
                                        dispatch(setSECNameRenew(value)); 
                                        setShowSuggestion(value.trim().length > 0); 
                                    }} 
                                    required={true} 
                                    placeholder={`Enter name of ${proposalTypeValue?.name}`} 
                                />

                                {showSuggestion && (
                                    <div className="absolute top-full left-0 right-0 z-50 mt-1 max-h-40 overflow-y-auto rounded-md border border-gray-200 bg-white shadow-lg">
                                        {isLoadingProposalForRenew || isFetchingProposalForRenew ? (
                                            <div className="px-3 py-2.5 text-xs text-gray-500">
                                                Loading...
                                            </div>
                                        ) : (proposalForRenew?.length ?? 0) > 0 ? (
                                            proposalForRenew?.map((item) => (
                                                <button key={item.application_id} type="button" className="w-full px-3 py-2 text-left text-xs text-gray-700 hover:bg-[#186cb2]/5 transition-colors" onClick={() => { dispatch(setSECNameRenew(item.group_name)); dispatch(setSelectedProposalToRenew({ id: item.application_id, name: item.group_name })); setShowSuggestion(false); }}>
                                                    {item.group_name}
                                                </button>
                                            ))
                                        ) : (
                                            <div className="px-3 py-2.5 text-xs text-gray-500">
                                                No result found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            <button onClick={handlePopulateRenewProposal} className="shrink-0 rounded-md bg-[#186cb2] px-4 py-2 text-xs font-semibold text-white transition hover:bg-[#155d9c]">
                                Renew
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}